Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.TouchscreenType = module.exports.default = {
	FINGER: "finger",
	NONE: "none",
	STYLUS: "stylus"
};